import React from "react";

function CollectionIntroContentItem() {
    return (
        <section className="CollectionCortisIntro">
            <p className="CollectionCortisIntro-text">
                지난 8월, 빅히트 뮤직에서 6년 만에 선보인 보이그룹 코르티스(CORTIS)는 EP 1집 [COLOR OUTSIDE THE LINES]부터 크리에이티브 크루로서의 기량을 마음껏 선보였다. 선공개 곡 ‘GO!’는 세상에 던지는 코르티스의 출사표를 보여주었고, 뒤이어 공개된 타이틀 ‘What You Want’는 원하는 것을 주저하지 않고 손에 넣겠다는 선언을 보여주었다. 특히 사막 한가운데에서 트레드밀을 활용한 원테이크 퍼포먼스에서는 그들의 열정을 고스란히 느낄 수 있었다.
            </p>
            <p className="CollectionCortisIntro-text">
                하지만 그들의 가장 큰 매력은 스스로를 인위적으로 꾸미거나 포장하지 않는다는 점이다. 평균 나이 17세 소년의 일상, 좋아하는 것들, 생각하는 방식을 음악에 있는 그대로 담아 진솔한 감정을 이야기한다. 그렇기 때문에 데뷔한 지 한 달도 채 안 되는 짧은 기간에 벌써 대중의 마음을 사로잡은 건 아닐까.
            </p>
            <p className="CollectionCortisIntro-text">
                {`후속곡 ‘FaSHioN’ 속 “후르츠 찜해놓은 상품에 있었던 벨트는 now on my 허리”라는 가사 역시 마찬가지다. 다듬어지지 않은 날 것의 가사는 빅히트 뮤직과 후루츠의 회사 간 공식 협업으로 성사된 ‘한 줄’이 아닌, 실제 후루츠를 사용하는 멤버들이 내뱉은 진솔함이었다. 연출로는 만들 수 없는 디테일, 진심이 아니면 나올 수 없는 가사.`}
            </p>
            <p className="CollectionCortisIntro-text">
                실제로 후루츠에서 디깅하고, 찜하고, 네고 하는 습관도 우리들과 똑같은 다섯 명의 청춘. 음악처럼 패션도 진심인 <strong>마틴.</strong> Hats, Caps, Beanies 4 Life라 말하는 <strong>제임스.</strong> 에디 슬리먼의 무드를 좇는 <strong>주훈</strong>, 피트 도허티의 패션을 동경하는 <strong>성현</strong>, 그리고 &lsquo;후루츠&rsquo;를 가사에 녹여낸 <strong>건호</strong>까지. 좋아하는 패션도 스타일도 제각기 다른 &lsquo;크리에이터 크루&rsquo; 코르티스 다섯 멤버의 취향을 후루츠가 직접 물어봤다.
            </p>
        </section>
    );
}

export default React.memo(CollectionIntroContentItem);
